<template>
  <fieldset>
    <div class="flex justify-center align-center margin-bottom-sm">
      <input
        v-model.number="topModel"
        type="number"
        min="0"
        step="1"
        class="input"
        data-test="spacing-element-top-input"
      />
    </div>

    <div class="flex justify-between align-center margin-bottom-sm">
      <input
        v-model.number="leftModel"
        type="number"
        min="0"
        step="1"
        class="input"
        :disabled="locked"
        data-test="spacing-element-left-input"
      />

      <label
        class="lock"
        :data-test="`spacing-element-lock`"
      >
        <input
          v-model="locked"
          type="checkbox"
          class="lock__input"
          :data-test="`spacing-element-lock-input`"
        >
        <span
          class="lock__icon fa-fw"
          :class="locked ? 'fas fa-lock' : 'fas fa-lock-open'"
        />
      </label>

      <input
        v-model.number="rightModel"
        type="number"
        min="0"
        step="1"
        class="input"
        :disabled="locked"
        data-test="spacing-element-right-input"
      />
    </div>

    <div class="flex justify-center align-center">
      <input
        v-model.number="bottomModel"
        type="number"
        min="0"
        step="1"
        class="input"
        :disabled="locked"
        data-test="spacing-element-bottom-input"
      />
    </div>
  </fieldset>
</template>

<script>
export default {
  emits: ['update:top', 'update:right', 'update:bottom', 'update:left'],
  name: 'PaddingSettingsPanel',
  props: {
    top: {
      type: Number,
      required: true,
    },
    right: {
      type: Number,
      required: true,
    },
    bottom: {
      type: Number,
      required: true,
    },
    left: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      locked: this.top === this.right
        && this.top === this.bottom
        && this.top === this.left,
    };
  },
  computed: {
    topModel: {
      get() {
        return this.top;
      },
      set(v) {
        this.$emit('update:top', v);
        if (this.locked) {
          this.$emit('update:right', v);
          this.$emit('update:bottom', v);
          this.$emit('update:left', v);
        }
      },
    },
    rightModel: {
      get() {
        return this.right;
      },
      set(v) {
        this.$emit('update:right', v);
      },
    },
    bottomModel: {
      get() {
        return this.bottom;
      },
      set(v) {
        this.$emit('update:bottom', v);
      },
    },
    leftModel: {
      get() {
        return this.left;
      },
      set(v) {
        this.$emit('update:left', v);
      },
    },
  },
  watch: {
    locked(newVal) {
      if (newVal) {
        const value = this.top;
        this.$emit('update:right', value);
        this.$emit('update:bottom', value);
        this.$emit('update:left', value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.input {
  width: 33%;
  margin: 2px;
}

.lock {
  display: block;
  position: relative;
  cursor: pointer;
  padding: 8px;
  margin: 0;
  // background-color: var(--surface-200);
  border-radius: 4px;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1px;
    height: 100%;
    // border-left: 1px dashed var(--surface-500);
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 1px;
    // border-top: 1px dashed var(--surface-500);
  }

  &__input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  &__icon {
    position: relative;
    z-index: 1;
    // background-color: var(--surface-200);
  }
}
</style>
